import { testimonials } from "@/mocks/homeContent";

const aboutPoints = [
  {
    icon: "ri-compass-3-line",
    title: "我们是谁",
    text: "校园吃瓜网是一个由高校内容爱好者共建的匿名分享社区，为想分享又不想露脸的同学，提供一个有温度的树洞。",
  },
  {
    icon: "ri-lightbulb-flash-line",
    title: "发展理念",
    text: "我们相信，日常小事也值得被认真倾听。用匿名降低表达门槛，用规则守护表达边界，让分享既自由又安全。",
  },
  {
    icon: "ri-shield-user-line",
    title: "内容原则",
    text: "只聊事不聊人、不造谣不引战、隐私优先、友善第一。每一篇上榜内容，都会先经过小编的去标识化审阅。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-16 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-team-line" aria-hidden="true" />
            关于我们
          </p>
          <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            一个想让你放心说话的树洞
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            校园吃瓜网诞生于一个朴素的念头：那些没处讲的身边事、想吐槽的日常、被悄悄暖到的瞬间，
            不该因为没有“合适的人”而烂在肚子里。我们把投稿箱做得足够轻，把守则立得足够稳，
            剩下的，交给你放心说。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
          {aboutPoints.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-2xl text-background-50">
                <i className={p.icon} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-xl font-semibold text-foreground-950">
              他们怎么说
            </h3>
            <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-star-fill text-accent-500" aria-hidden="true" />
              来自投稿箱与评论区
            </span>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
              >
                <div className="flex gap-1 text-accent-500" aria-label="5 星评价">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <i key={n} className="ri-star-fill text-sm" aria-hidden="true" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-primary-600">
                    <i className="ri-user-smile-line" aria-hidden="true" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}